import logo from "./logo.svg";
import "./assets/style/style.css";
import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import AppRoute from "./app/routes";
import { ToastContainer, toast } from "react-toastify";
import UserProvider from "./context/UserProvider";
import "react-toastify/dist/ReactToastify.css";
import store from "./app/redux/slices/newsletterManagement/store";
import { Provider } from "react-redux";
import ScrollToTop from "./app/components/ScrollToTop";

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Provider store={store}>
        <UserProvider>
          <ScrollToTop />
          <AppRoute />
        </UserProvider>
      </Provider>
      <ToastContainer
        position="top-right" // positions: top-right, top-center, top-left, bottom-right, etc.
        autoClose={3000} // closes after 3 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // colored, dark, light
      />
    </>
  );
}

export default App;
